<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item">
            <TextFilter :label-text="$t('common.supplier')"
                        columnName="supplierName"
                        ref="filter_supplierName"
            ></TextFilter>
            <TextFilter :label-text="$t('common.seller')"
                        columnName="sellerName"
                        ref="filter_sellerName"
            ></TextFilter>
            <FromToFilter :label-text="$t('common.amount')"
                          columnName="amount"
                          ref="filter_amount"
            ></FromToFilter>
            <CurrencyFilter columnName="currency"
                            ref="filter_currency"
            ></CurrencyFilter>
            <DateFilter :label-text="$t('common.dueDate')"
                        columnName="dueDate"
                        ref="filter_dueDate"
            ></DateFilter>
        </div>
    </TableFilter>
</template>

<script>
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import CurrencyFilter from "@/components/newFilter/CurrencyFilter";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: { TableFilter, TextFilter, FromToFilter, DateFilter, CurrencyFilter },
    data() {
        return {};
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    }
};
</script>